module.exports = __webpack_public_path__ + "img/quality@2x.af00472.webp";